import React from 'react';
import {NavLink} from 'react-router-dom';
import 'components/sidebar/_sidebar.scss';
import {routes, utils} from 'common';
import {IoIosNotifications} from 'react-icons/io';
import {GiBookCover, GiBurningRoundShot} from 'react-icons/gi';
import {FaCheckToSlot} from 'react-icons/fa6';
import {RiMoneyDollarBoxFill} from 'react-icons/ri';
import {PiHandWithdrawFill} from 'react-icons/pi';
import {HiOutlineStatusOffline} from 'react-icons/hi';
import {useDispatch, useSelector} from 'react-redux';
import {generalActions} from 'reduxStore/reducers/generalSlice';
import {FaThList, FaUserCog, FaUserEdit, FaTools, FaCalendarAlt} from 'react-icons/fa';
import {ADMIN_PERMISSIONS, GROUND_ADMIN_PERMISSIONS, ROLES} from 'common/constants';
import {MdAnalytics, MdReport} from 'react-icons/md';
import {IconProfile} from 'assets/icons';

// Add requiredPermission for each nav item (use backend permission keys)
const groundOwnerNavItems = [
  {label: 'Ground Management', path: routes.GROUNDS, icon: <GiBurningRoundShot/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.GROUNDS},
  {label: 'Field Management', path: routes.SLOTS, icon: <FaCheckToSlot/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.SLOTS},
  {label: 'Booking Management', path: routes.BOOKINGS, icon: <GiBookCover/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.BOOKINGS},
  {label: 'Booking Calendar', path: routes.CALENDAR, icon: <FaCalendarAlt/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.BOOKINGS},
  {label: 'Earnings Dashboard', path: routes.EARNINGS, icon: <RiMoneyDollarBoxFill/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.EARNING},
  {label: 'Withdraw Request', path: routes.WITHDRAW_REQUEST, icon: <PiHandWithdrawFill/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.WITHDRAW},
  {label: 'Notifications Center', path: routes.NOTIFICATIONS, icon: <IoIosNotifications/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.NOTIFICATIONS},
  {label: 'Offline Booking', path: routes.OFFLINE_BOOKING, icon: <HiOutlineStatusOffline/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.OFFLINE_BOOKINGS},
  {label: 'Maintenance', path: routes.MAINTENANCE, icon: <FaTools/>, requiredPermission: GROUND_ADMIN_PERMISSIONS.MAINTENANCE},
];

const adminNavItems = [
  {label: 'User Management', path: routes.USERS, icon: <FaUserEdit/>, requiredPermission: ADMIN_PERMISSIONS.USERS},
  {label: 'Role Management', path: routes.ROLES, icon: <FaUserCog/>, requiredPermission: ADMIN_PERMISSIONS.ROLES},
  {label: 'Listing Approvals', path: routes.APPROVAL, icon: <FaThList/>, requiredPermission: ADMIN_PERMISSIONS.APPROVALS},
  {label: 'Report Handling', path: routes.REPORTS, icon: <MdReport/>, requiredPermission: ADMIN_PERMISSIONS.REPORTS},
  {label: 'Analytics Dashboard', path: routes.ANALYTICS, icon: <MdAnalytics/>, requiredPermission: ADMIN_PERMISSIONS.ANALYTICS},
  {label: 'Withdrawal Requests', path: routes.ADMIN_WITHDRAWALS, icon: <PiHandWithdrawFill/>, requiredPermission: ADMIN_PERMISSIONS.WITHDRAWALS},
];

const SIDEBAR_DRAWER_BREAKPOINT = 768; // match layout: below this = drawer, above = persistent

const Sidebar = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const {user} = useSelector(state => state.auth);
  console.log(user)
  const isAdmin = user.role === ROLES.ADMIN;
  const navItems = (isAdmin ? adminNavItems : groundOwnerNavItems).filter(item => utils.hasPermission(user, item.requiredPermission));
  const pic = user.pic ? user.pic : IconProfile;

  // Only close sidebar when in drawer mode (small/medium). On large screens keep it open on nav.
  const closeSidebar = () => {
    if (window.innerWidth < SIDEBAR_DRAWER_BREAKPOINT) {
      dispatch(generalActions.setSidebarOpen(false));
    }
  };

  return (
    <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`} aria-hidden={!isOpen}>
      <div className="sidebar-inner">
      <nav className="sidebar-nav">
        {navItems.map(item => (
          <NavLink
            key={item.label}
            to={item.path}
            className={({isActive}) =>
              isActive ? 'sidebar-link active' : 'sidebar-link'
            }
            onClick={closeSidebar}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <NavLink
        to={routes.PROFILE}
        className={({isActive}) =>
          isActive ? 'sidebar-profile active' : 'sidebar-profile'
        }
        onClick={closeSidebar}
      >
        <img className="sidebar-profile-img" src={pic} alt="Profile"/>
        <div>
          <div className="sidebar-profile-name">My Profile</div>
        </div>
      </NavLink>
      </div>
    </aside>
  );
};

export default Sidebar;